/// <amd-module name="Analytics/Shared/Visuals/ChartLegend/ChartLegend" />
import * as React from "react";
import { css } from "VSSUI/Util";
import { Tooltip } from "VSSUI/TooltipEx";

export interface IChartLegend {
    label: string;
    color: string;
}

export interface IChartLegendProps {
    className?: string;
    legend: IChartLegend[];
}

export class ChartLegendComponent extends React.PureComponent<IChartLegendProps, {}> {
    public render(): JSX.Element {
        const legends: JSX.Element[] = [];
        this.props.legend.forEach(l => {
            legends.push(
                <Tooltip text={l.label}>
                    <div key={l.label} className="flex-row">
                        <div className="legend-color" style={{ backgroundColor: l.color }} />
                        <div className="legend-labels text-ellipsis">
                            {l.label}
                        </div>    
                    </div>
                </Tooltip>
            );
        });
        return (
            <div className={css("barchart-legend-container", "flex-column", this.props.className || "")}>
                {legends.map(legend => {
                    return legend;
                })}
            </div>
        );
    }
}
